import { render, staticRenderFns } from "./employeeentry.vue?vue&type=template&id=985d8c28&scoped=true&"
import script from "./employeeentry.vue?vue&type=script&lang=js&"
export * from "./employeeentry.vue?vue&type=script&lang=js&"
import style0 from "./employeeentry.vue?vue&type=style&index=0&id=985d8c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985d8c28",
  null
  
)

export default component.exports